import { supabase } from './supabaseClient';
import { trackEvent } from './track';

/* ══════════════════════════════════════════════════════════════════════════
   A LANDING MEGNYITÁSA A SESSION ÁTADÁSÁVAL
   ─────────────────────────────────────────────────────────────────────────
   A terminál és a web3kurzus.hu KÜLÖN ALDOMAIN, tehát külön localStorage és
   külön session. Aki itt be van lépve, ott kijelentkezett — és a magic link
   újrakérése pont a fizetési döntés pillanatában akasztja meg.

   A tokenek a HASH-ben mennek (#w3k_handoff=1&w3k_at=...), NEM query paraméterben:
   a hash-t a böngésző nem küldi el a szervernek, így nem kerül se a Netlify,
   se a Supabase hozzáférési logjába. A query paraméter viszont igen.

   KORÁBBI HIBA, amit ez javít: a Header.js query paraméterrel küldte a
   tokent a /dashboard-ra, a landing viszont SEHOL nem olvasott access_token-t
   az URL-ből — az az átadás tehát sosem működött, a felhasználó mindig
   kijelentkezve érkezett meg.

   A fület a kattintáskor nyitjuk, az await ELŐTT: await után a böngésző
   popup-blokkolója megfogja (lásd a landing src/terminal.js-ét, ugyanez a
   hiba élt ott három hónapig).
   ══════════════════════════════════════════════════════════════════════════ */

export const LANDING_URL = 'https://web3kurzus.hu';
/* The egyetem reads the SAME hash format on every path (egyetem repo
   src/handoffCapture.js); the landing opens it at /tanfolyamok as well. */
export const EGYETEM_URL = 'https://egyetem.web3kurzus.hu';

/* Saját kulcsnevek, `w3k_` előtaggal.

   NEM lehet `access_token` a neve. Az első változat azt használta, és a
   `type=handoff` jelölőtől vártuk a megkülönböztetést — de a supabase-js nem
   nézi a `type`-ot, csak az `access_token` puszta jelenlétét:

       _isImplicitGrantCallback(params) {
         return Boolean(params.access_token || params.error_description)
       }

   és a `parseParametersFromURL()` a hash-t is beolvassa. A landing kliense
   ezért saját implicit-grant visszatérésének hitte az átadásunkat, majd
   elhasalt rajta (hiányzó `expires_in` / `token_type`), és megszakította a
   saját inicializálását. Részletesen: a landing repó
   docs/elakadasi-pontok-2026-09.md 0.1-es tétele.

   A `detectSessionInUrl` a landingen BEKAPCSOLVA MARAD — a magic-link
   belépés arra épül —, csak a mi átadásunk nem esik a felismerése alá. */
const HANDOFF_FLAG = 'w3k_handoff';
const HANDOFF_AT = 'w3k_at';
const HANDOFF_RT = 'w3k_rt';

/* A cél-horgony (pl. '/plusz#arak') nem maradhat a hash-ben, mert az a
   tokeneké: w3k_anchor-ként megy, és a landing a takarítás után visszaírja
   (landing src/sessionHandoff.js). Munkamenet nélkül a horgony marad. */
function withSession(base, path, session) {
  const token = session?.access_token;
  const refresh = session?.refresh_token;
  if (!token || !refresh) return `${base}${path}`;
  const [bare, anchor] = path.split('#');
  const hash = new URLSearchParams({
    [HANDOFF_FLAG]: '1',
    [HANDOFF_AT]: token,
    [HANDOFF_RT]: refresh,
    ...(anchor ? { w3k_anchor: anchor } : {}),
  }).toString();
  return `${base}${bare}#${hash}`;
}

/**
 * Megnyitja a landing egy oldalát, a bejelentkezett sessiont átadva.
 * MINDIG kattintás-kezelőből hívd, szinkron módon.
 *
 * @param {string} path      pl. '/pro' vagy '/dashboard'
 * @param {object} opts
 * @param {object} opts.user      a trackEvent-hez
 * @param {string} opts.event     az esemény neve (pl. 'pro_cta_clicked')
 * @param {object} opts.eventProps  további mezők az eseményhez
 */
/* Egy egyetemi útvonal teljes címe a session átadásával (a visszatéréshez, returnTo.js). */
export const egyetemUrl = (path, session) => withSession(EGYETEM_URL, path, session);

export function openLanding(path, opts = {}) {
  openWithSession(LANDING_URL, path, opts);
}

/** Opens an egyetem.web3kurzus.hu page with the session handed over. */
export function openEgyetem(path = '/tanfolyamok', opts = {}) {
  openWithSession(EGYETEM_URL, path, opts);
}

function openWithSession(base, path, { user, event, eventProps } = {}) {
  if (event) trackEvent(event, eventProps || {}, user);

  const w = window.open('', '_blank');
  const blocked = !w;

  const finish = (url) => {
    if (blocked) { window.location.href = url; return; }
    w.location.href = url;
  };

  supabase.auth.getSession()
    .then(({ data: { session } }) => finish(withSession(base, path, session)))
    /* Ha a session nem szerezhető meg, akkor is átvisszük — ott bejelentkezhet.
       Jobb, mint egy néma, üres fül. */
    .catch(() => finish(`${base}${path}`));
}
